import axios from 'axios';
import { getClerkToken } from '../../lib/clerkToken';

export const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getClerkToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res.data,
  (err) => {
    const msg =
      err.response?.data?.message ??
      err.response?.data?.error ??
      err.message ??
      'Something went wrong';
    const error = new Error(msg) as Error & { status?: number };
    error.status = err.response?.status;
    return Promise.reject(error);
  },
);

export const api = {
  get: <T>(path: string) => apiClient.get<T, T>(path),
  post: <T>(path: string, body?: unknown) => apiClient.post<T, T>(path, body),
  patch: <T>(path: string, body?: unknown) => apiClient.patch<T, T>(path, body),
  delete: <T>(path: string) => apiClient.delete<T, T>(path),
};
